import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'minimal-formly-field-wrapper',
  template: ` <p-divider
      *ngIf="
        props && props.attributes && props.attributes['separator']
      "
    ></p-divider>
    <div class="field p-fluid mb-3 mt-1">
      <ng-container #fieldComponent></ng-container>
    </div>`,
})
export class MinimalFieldWrapperComponent extends FieldWrapper {}
